import React from "react";
import DropDeskIcon from "@dropDesk/storage/icons";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import {hexToRGBA} from "@dropDesk/utils/helpers/colors";
import {SharedColors} from "@dropDesk/domain/entities/theme/app_colors";
import {ComparativeDirection} from "@dropDesk/domain/entities/reports/report_ticket_comparative/comparative_metric.entity";

export const formatVariationPercent = (value: number): string => {
    const abs = Math.abs(value);
    if (abs === 0) {
        return '0%';
    }
    const formatted = abs % 1 === 0
        ? abs.toFixed(0)
        : abs.toLocaleString('pt-BR', {maximumFractionDigits: 2});
    return `${formatted}%`;
};

export const getPillTone = (
    direction: ComparativeDirection,
    isImprovement: boolean,
    hint: string,
): {color: string; background: string} => {
    if (direction === 'stable') {
        return {
            color: hint,
            background: hexToRGBA(hint, 0.15),
        };
    }
    if (isImprovement) {
        return {
            color: SharedColors.success,
            background: hexToRGBA(SharedColors.success, 0.15),
        };
    }
    return {
        color: SharedColors.errorOnPrimary,
        background: hexToRGBA(SharedColors.errorOnPrimary, 0.15),
    };
};

export const DirectionIcon = ({direction, color}: {direction: ComparativeDirection; color: string}) => {
    if (direction === 'stable') {
        return <span style={{lineHeight: 1}}>—</span>;
    }
    return (
        <DropDeskIcon
            icon={ICONS_DROPDESK.arrowDown}
            size={12}
            color={color}
            style={{transform: direction === 'up' ? 'rotate(180deg)' : undefined}}
        />
    );
};
